import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { FormControl, FormHelperText, TextField, Typography, InputLabel, Select, MenuItem, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { MerchantActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const MerchantStepTwo = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    const { token } = useSelector(IdentitySelector); 

    const { control, errors, handleSubmit, watch } = useForm();

    const { classes } = props;

    //sub category code
    const [subcategory, setSubCategory] = React.useState(null);

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        currentState[name] = value;

        if (name.startsWith('category_code')) {
            // 選択された業種カテゴリー配下の業種サブカテゴリーに切り替え
            const matchedCategory = editing.merchantCategoryCodes.filter(category => category.category_code == value);
            setSubCategory(matchedCategory);
        }

        return value;
    }

    //next button
    const handleNext = () => {
        props.handleNext();
    };

    //back button
    const handleBack = () => {
        props.handleBack();
    };

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        // 初期レンダリングの時のみ業種カテゴリーが選択されている場合、業種サブカテゴリー一覧を設定
        if (editing.category_code != null && editing.category_code != undefined && editing.category_code != '') {
            const matchedCategory = editing.merchantCategoryCodes.filter(category => category.category_code == editing.category_code);
            setSubCategory(matchedCategory);
        }
    }, []);

    // 設立年月日
    var establishmentDt = null;
    if (editing.establishment_dt != null) {
        var dt = new Date(editing.establishment_dt);
        establishmentDt = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
    }

    // 業種サブカテゴリー一覧
    var subcategoryElement = '';
    if (subcategory != null) {
        subcategoryElement =
            <Grid item xs={6}>
                <FormControl required fullWidth variant="outlined" error={errors.subcategory_code && true}>
                    <InputLabel id="merchant-label-subcategory_code"><FormattedMessage id={"Merchant.IndustrySubCategory"} /></InputLabel>
                    <Controller
                        name="subcategory_code"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.subcategory_code ? editing.subcategory_code : ''}
                        rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                        as={<Select
                            labelId="merchant-label-subcategory_code"
                            id="merchant-subcategory-code"
                            label={<FormattedMessage id={"Merchant.IndustrySubCategory"} />}>
                            {subcategory.map((x) => {
                                return <MenuItem key={x.subcategory_code} value={x.subcategory_code}>{x.subcategory_name}</MenuItem>
                            })}
                        </Select>} />
                    <FormHelperText>{errors.subcategory_code ? errors.subcategory_code.message : ""}</FormHelperText>
                </FormControl>
            </Grid>;
    }

    // 非必須項目の値がnullの場合、必須チェックで引っかかるため空文字設定（数値変数も初期化）
    if (editing.merchant_fax == null || editing.merchant_fax == undefined) {
        editing.merchant_fax = "";
    }
    if (editing.capital == null || editing.capital == undefined) {
        editing.capital = "";
    }
    if (editing.annual_sale == null || editing.annual_sale == undefined) {
        editing.annual_sale = "";
    }
    if (editing.employees_number == null || editing.employees_number == undefined) {
        editing.employees_number = "";
    }

    // submitボタンのアイコンとタイトルを画面に応じて変更
    var submitIcon;
    var submitTitle;
    if (props.mode == "regist") {
        // 登録時：次へ
        submitIcon = <ArrowForwardIosIcon />;
        submitTitle = <FormattedMessage id="Button.Next" />;
    }
    else {
        // 更新時：入力し内容に変更
        submitIcon = <SaveIcon />;
        submitTitle = <FormattedMessage id="Button.Update" />;
    }

    // 加盟店入力チェック値
    var shopCd1Pattern = /[0-9]{13}/i;
    var shopCd1MaxLength = 13;
    var shopCd2Pattern = /[0-9]{4}/i;
    var shopCd2MaxLength = 4;

    return (
        <form className={classes.form} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl required fullWidth variant="outlined" error={errors.business_form && true}>
                        <InputLabel id="merchant-business-form"><FormattedMessage id={"Merchant.BusinessForm"} /></InputLabel>
                        <Controller
                            name="business_form"
                            control={control}
                            onChange={onChange}
                            rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                            defaultValue={editing.business_form}
                            as={<Select
                                labelId="merchant-business-form"
                                id="merchant-business-type"
                                label={<FormattedMessage id={"Merchant.BusinessForm"} />}>
                                <MenuItem value={1}><FormattedMessage id="Merchant.Corporate" /></MenuItem>
                                <MenuItem value={2}><FormattedMessage id="Merchant.IndividualBusiness" /></MenuItem>
                            </Select>} />
                        <FormHelperText>{errors.category_code ? errors.category_code.message : ""}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="corporat_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.corporat_name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantCorporatNameMaxLenPattern" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.corporat_name && true}
                            helperText={errors.corporat_name ? errors.corporat_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 沖縄ICカード株式会社</Typography>}
                            label={<FormattedMessage id={"Merchant.CorporateName"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="corporat_f_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.corporat_f_name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantCorporatNameMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[ァ-ヶー０-９]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.KatakanaName" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.corporat_f_name && true}
                            type="text"
                            helperText={errors.corporat_f_name ? errors.corporat_f_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} オキナワアイシーカードカブシキガイシャ</Typography>}
                            label={<FormattedMessage id={"Merchant.CorporateNameInFurigana"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="corporat_no"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.corporat_no ? editing.corporat_no : ''}
                        rules={{
                            //required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 12, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantCorporatNoMinLenPattern" />}</Typography> },
                            maxLength: { value: 12, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantCorporatNoMaxLenPattern" />}</Typography> }
                        }}
                        //as={<TextField required fullWidth variant="outlined"
                        as={<TextField fullWidth variant="outlined"
                            error={errors.corporat_no && true}
                            type="text"
                            helperText={errors.corporat_no ? errors.corporat_no.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 236000101759</Typography>}
                            label={<FormattedMessage id={"Merchant.CorporateNumber"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="shop_cd_1"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_cd_1}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: shopCd1MaxLength, message: <Typography component="h6">{<FormattedMessage id="Error.ShopCd1_Pattern" />}</Typography> },
                            pattern: { value: shopCd1Pattern, message: <Typography component="h6"><FormattedMessage id={"Error.ShopCd1_Pattern"} /></Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_cd_1 && true}
                            type="text"
                            helperText={errors.shop_cd_1 ? errors.shop_cd_1.message : <Typography component="h6">※ {<FormattedMessage id="Label.ShopCd1" />}</Typography>}
                            label={<FormattedMessage id={"Merchant.StoreCodeLevel1"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="shop_cd_2"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_cd_2.trim() ? editing.shop_cd_2.trim() : ''}
                        rules={{
                            maxLength: { value: shopCd2MaxLength, message: <Typography component="h6">{<FormattedMessage id="Error.ShopCd2_Pattern" />}</Typography> },
                            pattern: { value: shopCd2Pattern, message: <Typography component="h6"><FormattedMessage id={"Error.ShopCd2_Pattern"} /></Typography> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.shop_cd_2 && true}
                            type="text"
                            helperText={errors.shop_cd_2 ? errors.shop_cd_2.message : <Typography component="h6">※ {<FormattedMessage id="Label.ShopCd2" />}</Typography>}
                            label={<FormattedMessage id={"Merchant.StoreCodeLevel2"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <FormControl required fullWidth variant="outlined" error={errors.shop_cd_type && true}>
                        <InputLabel id="merchant-corpo-code-type"><FormattedMessage id={"Merchant.CorporateCodeType"} /></InputLabel>
                        <Controller
                            name="shop_cd_type"
                            control={control}
                            onChange={onChange}
                            rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                            defaultValue={editing.shop_cd_type}
                            as={<Select
                                labelId="merchant-corpo-code-type"
                                id="merchant-corpo-code"
                                label={<FormattedMessage id={"Merchant.CorporateCodeType"} />}>
                                <MenuItem value={1}><FormattedMessage id="Merchant.CorporateCodeTypeOkica" /></MenuItem>
                                {/* 2020.09.30 JPQR未対応 */}
                                {/*<MenuItem value={2}><FormattedMessage id="Merchant.CorporateCodeTypeJPQR" /></MenuItem>*/}
                            </Select>} />
                        <FormHelperText>{errors.category_code ? errors.category_code.message : ""}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="merchant_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.merchant_name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 25, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantNameMaxLenPattern" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.merchant_name && true}
                            type="text"
                            helperText={errors.merchant_name ? errors.merchant_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 沖縄タクシー</Typography>}
                            label={<FormattedMessage id={"Merchant.Name"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="merchant_e_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.merchant_e_name}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 100, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantEnglishNameMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9a-zA-Z ._-]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Hankakueisu" />} </Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.merchant_e_name && true}
                            type="text"
                            helperText={errors.merchant_e_name ? errors.merchant_e_name.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} OkinawaTaxi</Typography>}
                            label={<FormattedMessage id={"Merchant.NameInEng"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="merchant_postal_code"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.merchant_postal_code}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 7, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantPostalMinLenPattern" />}</Typography> },
                            maxLength: { value: 7, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantPostalMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantPostalMaxLenPattern" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.merchant_postal_code && true}
                            helperText={errors.merchant_postal_code ? errors.merchant_postal_code.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 8700823</Typography>}
                            label={<FormattedMessage id={"Merchant.PostalCode"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="merchant_address"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.merchant_address}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 100, message: <Typography component="h6">{<FormattedMessage id="Error.AcquirerMerchantAdressMaxLenPattern" />}</Typography> },
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.merchant_address && true}
                            helperText={errors.merchant_address ? errors.merchant_address.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 大分県大分市東大道2丁目5番60号</Typography>}
                            label={<FormattedMessage id={"Merchant.Place"} />}
                            />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="merchant_tel"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.merchant_tel}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            minLength: { value: 10, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantTelFaxMinLenPattern" />}</Typography> },
                            maxLength: { value: 12, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantTelFaxMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.merchant_tel && true}
                            helperText={errors.merchant_tel ? errors.merchant_tel.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0975768181</Typography>}
                            label={<FormattedMessage id={"Merchant.PhoneNumber"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="merchant_fax"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.merchant_fax}
                        rules={{
                            minLength: { value: 10, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantTelFaxMinLenPattern" />}</Typography> },
                            maxLength: { value: 12, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantTelFaxMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.merchant_fax && true}
                            helperText={errors.merchant_fax ? errors.merchant_fax.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0975768182</Typography>}
                            label={<FormattedMessage id={"Merchant.FaxNumber"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="capital"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.capital}
                        rules={{
                            maxLength: { value: 9, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantCapitalMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.capital && true}
                            type="number"
                            helperText={errors.capital ? errors.capital.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 1,000,000,000</Typography>}
                            label={<FormattedMessage id={"Merchant.Capital"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="annual_sale"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.annual_sale}
                        rules={{
                            maxLength: { value: 9, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantAnnualSaleMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.annual_sale && true}
                            type="number"
                            helperText={errors.annual_sale ? errors.annual_sale.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 100,000,000</Typography>}
                            label={<FormattedMessage id={"Merchant.AnnualSales"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="establishment_dt"
                        control={control}
                        onChange={onChange}
                        as={<TextField fullWidth variant="outlined"
                            id="establishment_dt"
                            label={<FormattedMessage id={"Merchant.EstablishDate"} />}
                            type="date"
                            defaultValue={establishmentDt}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />}
                    />
                </Grid>
                <Grid item xs={6}>

                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="employees_number"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.employees_number}
                        rules={{
                            maxLength: { value: 5, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantEmployeesNumberMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            type="number"
                            error={errors.employees_number && true}
                            helperText={errors.employees_number ? errors.employees_number.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 100</Typography>}
                            label={<FormattedMessage id={"Merchant.NoOfEmployees"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="temp_number"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.temp_number}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: 4, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantTempNumberMaxLenPattern" />}</Typography> },
                            pattern: { value: /^[0-9]+$/i, message: <Typography component="h6">{<FormattedMessage id="Error.Number" />}</Typography> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            type="number"
                            error={errors.temp_number && true}
                            helperText={errors.temp_number ? errors.temp_number.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 5</Typography>}
                            label={<FormattedMessage id={"Merchant.NoOfStores"} />} />} />
                </Grid> 
                <Grid item xs={6}>
                    <FormControl required fullWidth variant="outlined" error={errors.category_code && true}>
                        <InputLabel id="merchant-label-category_code"><FormattedMessage id={"Merchant.IndustryCategory"} /></InputLabel>
                        <Controller
                            name="category_code"
                            control={control}
                            onChange={onChange}
                            defaultValue={editing.category_code ? editing.category_code : ''}
                            rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                            as={<Select
                                labelId="merchant-label-category_code"
                                id="merchant-category-code"
                                label={<FormattedMessage id={"Merchant.IndustryCategory"} />}>
                                {editing.selectableCategoryCodes.map((x) => {
                                    return <MenuItem key={x.category_code} value={x.category_code}>{x.category_name}</MenuItem>
                                })}
                            </Select>} />
                        <FormHelperText>{errors.category_code ? errors.category_code.message : ""}</FormHelperText>
                    </FormControl>
                </Grid>
                {subcategoryElement}
                <Grid item xs={12}>
                    <Controller
                        name="business_content"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.business_content}
                        rules={{
                            maxLength: { value: 500, message: <Typography component="h6">{<FormattedMessage id="Error.MerchantBusinessContentMaxLenPattern" />}</Typography> }
                        }}
                        as={<TextField fullWidth
                            multiline
                            rows={4}
                            rowsMax={5}
                            variant="outlined"
                            error={errors.business_content && true}
                            helperText={errors.business_content ? errors.business_content.message : ""}
                            label={<FormattedMessage id={"Merchant.BusinessDetail"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth required variant="outlined" error={errors.payment_cycle && true}>
                        <InputLabel id="payment-label-cycle"><FormattedMessage id={"Merchant.PaymentCycle"} /></InputLabel>
                        <Controller
                            name="payment_cycle"
                            control={control}
                            onChange={onChange}
                            rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                            defaultValue={editing.payment_cycle ? editing.payment_cycle : ''}
                            as={<Select
                                labelId="payment-label-cycle"
                                id="payment-cycle"
                                label={<FormattedMessage id={"Merchant.PaymentCycle"} />}>
                                <MenuItem value={1}><FormattedMessage id={"Merchant.PaymentCycle1"} /></MenuItem>
                                <MenuItem value={2}><FormattedMessage id={"Merchant.PaymentCycle2"} /></MenuItem>
                                <MenuItem value={3}><FormattedMessage id={"Merchant.PaymentCycle3"} /></MenuItem>
                            </Select>} />
                        <FormHelperText>{errors.payment_cycle ? errors.payment_cycle.message : ""}</FormHelperText>
                    </FormControl>
                </Grid>

                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium"
                        startIcon={<ArrowBackIosIcon />}
                        onClick={handleBack}><FormattedMessage id="Button.Back" /></Button>
                </Grid>
                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium" color="primary"
                        onClick={handleSubmit(handleNext)}
                        endIcon={submitIcon}>
                        {submitTitle}
                    </Button>
                </Grid>

            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(MerchantStepTwo);
